export const ORDER_STATUSES = [
  { value: "NEW", label: "New", color: "light-warning" },
  { value: "NEED_HELP", label: "Need Help", color: "light-warning" },
  { value: "DELIVERED", label: "Delivered", color: "light-success" },
  { value: "CLOSED", label: "Closed", color: "light-danger" },
  { value: "PAID", label: "Paid", color: "light-primary" },
  { value: "SENT", label: "Sent", color: "light-info" }
];
